const FormPopUp =  {
    _popUpNode: null,
    _closeEventRef: null,
    _closeBtn: null,
    _windowEventRef: null,

    init() {
        if(!document.querySelector('.js-form-popup')) return;

        let self = this;
        self._construct();
    },

    reInit() {
        let self = this;

        self._popUpNode = null;
        self._closeEventRef = null;
        self._closeBtn = null;
        self._windowEventRef = null;

        self.init();
    },

    _construct() {
        let self = this;
        self._popUpNode = document.querySelector('.js-form-popup');
    },

    openPopUp() {
        let self = this;

        if(self._popUpNode.classList.contains('hidden')) {
            self._popUpNode.classList.remove('hidden');
        }
        
        self._closeBtn = self._popUpNode.querySelector('.js-form-popup--close-btn');
        self._closeEventRef = self._closePopUp.bind(this, false);
        self._closeBtn.addEventListener('click', self._closeEventRef, false);

        setTimeout(() => {
            self._windowEventRef = self._closePopUp.bind(this, true);
            window.addEventListener('click', self._windowEventRef, false);
        });
    },

    _closePopUp(isWindowEvnt) {
        let self = this;

        if(isWindowEvnt) {
            if(event.target === self._popUpNode) {
                self._popUpNode.classList.add('hidden');
                window.removeEventListener('click', self._windowEventRef, false);
            }
        }
        else {
            if(!self._popUpNode.classList.contains('hidden')) {
                self._popUpNode.classList.add('hidden');
                self._closeBtn.removeEventListener('click', self._closeEventRef, false);
            }
        }        
    },
};
window.FormPopUp = FormPopUp;

window.FormPopUp.init();

document.addEventListener('LokiRequestEnd', function () {
    window.FormPopUp.reInit();
});